<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <!-- <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>{{config.phone}}
          <span class="glyphicon glyphicon-envelope"></span>{{config.email}}
          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div> -->
    <!-- 电脑导航 -->
    <div class="header-nav hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/logo_blue.png">
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="index==navIndex?'active':''"
          @click="navClick(index,item.name)"
        >
          <router-link :to="item.path">
            {{item.name}}
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <!-- <i class="underline"></i> -->
          </router-link>
          <dl v-if="item.children.length>0">
            <dt
              v-for="(i,n) in item.children"
              :key="n"
              :class="i.path == navPath?'nav-active':''"
              @click="toLInk(i.path)"
            >
              <!-- <router-link :to="i.path">{{i.name}}</router-link> -->
              <a>{{i.name}}</a>
            </dt>
          </dl>
        </li>
      </ul>
      <div class="header-nav-right">
          <!-- <Button type="primary">预约演示</Button> -->
          <div @click="handleReserve" class="header-nav-right-btn header-nav-right-btn1">
            <!-- <Button type="primary">登录</Button> -->
            <span>预约演示</span>
          </div>
          <div @click="toLogin" class="header-nav-right-btn header-nav-right-btn2">
            <!-- <Button type="primary">登录</Button> -->
            <span>登录</span>
          </div>
          <!-- <span class="glyphicon glyphicon-earphone"></span>{{config.phone}} -->
      </div>
    </div>
    <Modal v-model="reserveModal" title="1">
      <template #header>
        <p style="color:#f60;text-align:center">
          <Icon type="ios-information-circle"></Icon>
          <span>预约演示</span>
        </p>
      </template>
      <p class="contact-us">请扫二维码添加礼业帮官方企业微信号或者关注礼业帮官方微信公众号咨询</p>
      <div class="contact-qr">
        <div class="contact-qr-code">
          <img class="qr-code" src="@/assets/img/qr_code_1.png" alt="礼业帮微信公众号">
          <div>
            <p>扫码添加礼业帮</p>
            <p>官方企业微信号</p>
          </div>
        </div>
        <div class="contact-qr-code">
          <img class="qr-code" src="@/assets/img/qr_code.jpg" alt="礼业帮微信公众号">
          <div>
            <p>扫码关注礼业帮</p>
            <p>官方微信公众号</p>
          </div>
        </div>
      </div>
    </Modal>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/img/logo_blue.png" alt="logo">
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{menuName}}
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="index==navIndex?'active':''"
            @click="navClick(index,item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              {{item.name}}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import config from '@/config'
export default {
  name: "Header",
  data() {
    return {
      reserveModal: false,
      config: config,
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      navPath: "/software/couponMall",
      menuName: "网站首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "网站首页",
          path: "/",
          children: []
        },
        // {
        //   name: "产品服务",
        //   path: "/software",
        //   children: [
        //     {
        //       name: "Tessai资管后台系统",
        //       path: "/software/smartTown"
        //     },
        //     {
        //       name: "Tessai客户端系统",
        //       path: "/software/bigData"
        //     }
        //   ]
        // },
        {
          name: "产品服务",
          path: "/software",
          children: [
            {
              name: "卡券商城",
              path: "/software/couponMall"
            },
            {
              name: "福利商城",
              path: "/software/welfareMall"
            },
            {
              name: "客服托管",
              path: "/software/customerServiceHosting"
            },
            {
              name: "聚合供应链",
              path: "/software/aggregatedSupplyChain"
            },
            {
              name: "自有供应链",
              path: "/software/ownSupplyChain"
            },
          ]
        },
        // {
        //   name: "解决方案",
        //   path: "/service",
        //   children: [
        //     {
        //       name: "Tessai资管后台系统",
        //       path: "/software/smartTown"
        //     },
        //     {
        //       name: "Tessai客户端系统",
        //       path: "/software/bigData"
        //     }
        //   ]
        // },
        // {
        //   name: "成功案例",
        //   path: "/service",
        //   children: []
        // },
        {
          name: "新闻动态",
          path: "/newsinformation",
          children: []
        },
        {
          name: "关于我们",
          // path: "/aboutUs",
          path: "/aboutUs/companyintroduction",
          children: []
        },
        // {
        //   name: "工作机会",
        //   path: "/jobchance",
        //   children: []
        // },
        // {
        //   name: "联系我们",
        //   path: "/contactus",
        //   children: []
        // }
      ]
    };
  },
  watch:{
    $route(to,from){
      this.navPath = to.path
      if (to.name == 'home') {
        this.navIndex = 0;
      }
      if (to.name == 'software') {
        this.navIndex = 1;
      }
      if (to.name == 'newsinformation') {
        this.navIndex = 2;
      }
      if (to.name == 'aboutUs') {
        this.navIndex = 3;
      }
    }
  },
  methods: {
    navClick(index, name) {
      // this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    toLInk(path) {
      this.$router.push({path: path})
    },
    handleReserve() { // 预约演示
      // this.reserveModal = true
      window.open('https://f.wps.cn/ksform/w/write/VlXqa69d#routePromt','_blank');
    },
    toLogin() {
      window.open('http://channel.liyebang.com','_blank');
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #f4f4f4;
  transition: all ease 0.6s;
}
/* #header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
} */
/* 顶部的图标 */
/* #header .header-top span {
  margin: 0 8px;
} */
/* 导航栏 */
#header .header-nav {
  width: 100%;
  height: 60px;
  background-color: #FFFFFF;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  display: flex;
  justify-content: center;
  align-items: center;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 50px;
  height: 50px;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 60px;
  /* float: right; */
  margin: 0;
  max-width: 800px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 30px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #333333;
  font-size: 16px;
  font-weight: bold;
  /* padding: 15px 0; */
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #fff;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #3370FF;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active {
  /* background-color: blue; */
  /* color: #3370FF; */
}
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #3370FF;
  text-decoration: none;
  /* border-bottom: 2px solid #3370FF; */
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  border-radius: 4px 4px 4px 4px;
  font-size: 14px;
  color: #666;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  text-align: center;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #F4F4F4;
  color: #3370FF;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover a {
  color: #3370FF;
}
.nav-active {
  background: #F4F4F4;
}
#header .header-nav .header-nav-wrapper > li > dl .nav-active a {
  color: #3370FF;
}
/* 导航栏右侧 */
.header-nav-right {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #3370FF;
}
.header-nav-right-btn {
  height: 100%;
  padding: 20px;
  font-size: 16px;
}
.header-nav-right-btn1:hover {
  background-color: #3370FF;
  color: #FFFFFF;
}
.header-nav-right-btn2:hover {
  background-color: #3370FF;
  color: #FFFFFF;
}
.contact-us {
  text-align: center;
}
.contact-qr {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}
.contact-qr-code {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 50px;
}
.qr-code {
  width: 150px;
  height: 150px;
  margin-bottom: 10px;
}
.contact-qr-code p {
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  line-height: 1.4;
}

/* 媒体查询（手机） */
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {

}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue